import React, { FC } from 'react';
import DeliveryOrder, { DeliveryOrderCriteria } from 'src/interfaces/api/DeliveryOrder';
import useDeliveryOrder from 'src/hooks/api/useDeliveryOrder';
import DeliveryOrderTable from './DeliveryOrderTable';
import { Order } from 'src/interfaces/Table';

interface Props {
  searchCriteria: DeliveryOrderCriteria;
}

const DeliveryOrderTableContainer: FC<Props> = ({ searchCriteria }) => {
  const { getAll } = useDeliveryOrder();

  const handleGetAllDeliveryOrder = (page: number, limit: number, orderBy: keyof DeliveryOrder, order: Order) => {
    return getAll(searchCriteria, page, limit, orderBy, order);
  };

  return <DeliveryOrderTable onGetDeliveryOrders={handleGetAllDeliveryOrder} />;
};

export default React.memo(DeliveryOrderTableContainer);
